import { DealerContract } from './DealerContract';
import { Crop } from './Crop';
import { AdminSettingsOption, Manager } from '@types';

export interface DealerDocument {
  id: number;
  dealerId: number;
  fileId: number;
  adminUrl: string;
  url: string;
  isPdf: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface Dealer {
  activationId?: number | null;
  ciec?: string | null;
  clientLoan?: string | null;
  closeDate?: string | null;
  contacts?: DealerContact[];
  contracts?: DealerContract[];
  countActiveCredits?: number;
  countApplyingCredits?: number;
  countSignedCredits?: number;
  countUsers?: number;
  cropNames?: string[];
  crops?: Crop[];
  cropsIbm?: { crop: string, ibm: string }[];
  documents?: DealerDocument[];
  email: string | null;
  farmerCount?: string | null;
  financialVol?: number;
  harvestDate?: string | null;
  ibm?: string | null;
  ibms?: string[];
  id: number;
  image?: string;
  isCompany: boolean;
  lastUpdatedAt?: string | null;
  lastUpdatedName?: string | null;
  loanType?: string | null;
  manager?: Manager | null;
  mktStrategy?: string | null;
  name: string;
  owner: { name: string; id: number |null };
  ownerId: number | null;
  pBrands?: string[];
  pCategories?: string[];
  paymentType?: string | null;
  phone: string | null;
  position?: number;
  priority?: string | null;
  priorityId?: number | null;
  priorityObj?: AdminSettingsOption | null;
  productsIds?: number[];
  saleScope?: string | null;
  segment?: string | null;
  size?: string | null;
  source?: string | null;
  sowingDate?: string | null;
  state?: string | null;
  states?: string[];
  status?: AdminSettingsOption | null;
  statusId?: number | null;
  storeCount?: number | null;
  supplierLoan?: string | null;
  tier: string | DealerType;
  type?: DealerType;
  website?: string | null;
  yearsExp?: number | null;
}

export interface DealerComment {
  id: number;
  comment: string;
  adminId: number;
  adminName: string;
  dealerId: number;
  createdAt: string;
  updatedAt: string;
}

export interface DealerDocumentProps {
  idx: string;
  fileId: number | null;
  file: File | null;
  isPdf: boolean;
  preview: string;
  adminUrl: string;
  originalName: string;
}

export interface DealerDocumentRequest {
  id: number | null;
  file: string | null;
  name: string | null;
}

export enum DealerTier {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum DealerType {
  BUYER = 'buyer',
  RETAILER = 'retailer',
  ASSOCIATE = 'associate',
}

export enum DealerPaymentType {
  AA = 'AA',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}
export const dealerPaymentTypes: DealerPaymentType[] = [
  DealerPaymentType.AA, DealerPaymentType.A, DealerPaymentType.B,
  DealerPaymentType.C, DealerPaymentType.D,
];
export const dealerPaymentType: { id: DealerPaymentType, name: string }[] = [
  { id: DealerPaymentType.AA, name: 'AA (On Delivery)' },
  { id: DealerPaymentType.A, name: 'A (-30)' },
  { id: DealerPaymentType.B, name: 'B (-60)' },
  { id: DealerPaymentType.C, name: 'C (-90)' },
  { id: DealerPaymentType.D, name: 'D (+90)' },
];
export const dealerVerqorRR = {
  [DealerType.BUYER]: [
    'Rejected reason by Verqor',
    'Rechazo por riesgos',
    'No factura a los productores',
    'No cuenta con suficientes agricultores',
    'Productores informales',
    'No interesado en alianza',
    'No quiso retener',
    'Cuenta con otras opciones de financiamiento',
  ],
  [DealerType.RETAILER]: [
    'Rejected reason by Verqor',
    'Rechazo por riesgos',
    'No interesado en alianza',
    'Cuenta con otras opciones de financiamiento',
  ],
  [DealerType.ASSOCIATE]: [
    'Rejected reason by Verqor',
    'Rechazo por riesgos',
    'Productores informales',
    'No interesado en alianza',
    'Cuenta con otras opciones de financiamiento',
  ],
};

export const dealerTypeOptionsList = {
  [DealerType.BUYER]: ['AAA', 'CyE', 'Strategic Partner', 'Trader', 'Exporter', 'Broker', 'Ag-Input supplier', 'Seed', 'Ag-Structure', 'Machinery', 'Ag-Input manufacturer'],
  [DealerType.RETAILER]: ['AAA', 'CyE', 'Strategic Partner', 'Trader', 'Exporter', 'Broker', 'Ag-Input supplier', 'Seed', 'Ag-Structure', 'Machinery', 'Ag-Input manufacturer'],
  [DealerType.ASSOCIATE]: ['AAA', 'CyE', 'Strategic Partner', 'Consultant', 'Broker', 'Intern', 'ITC', 'Partner\'s workforce'],
};

export const dealerTiers = [DealerTier.A, DealerTier.B, DealerTier.C];
export const dealerTiersChoices = [
  { id: DealerTier.A, name: DealerTier.A },
  { id: DealerTier.B, name: DealerTier.B },
  { id: DealerTier.C, name: DealerTier.C },
];
export const dealerSupplierLoanChoices = [
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' },
];

export type DealerPartial = Omit<Dealer, 'id' | 'crops' | 'owner'>;

export interface DealerContact {
  name: string;
  position?: string;
  phone?: string;
  email?: string;
}
